import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { routines as modalRoutines } from '../../reducers/ui/modal';
import FormButton from '../../components/shared/FormButton';
import TextBox from 'devextreme-react/text-box';
import TextArea from 'devextreme-react/text-area';
import SelectBox from 'devextreme-react/select-box';
import DateBox from 'devextreme-react/date-box';
import {
  routines as decisionsActions,
  isSectionChecklistItemsForDealLoadingSelector,
  isSectionsLoadingSelector,
  sectionChecklistItemsForDealListSelector,
  sectionListSelector,
  isSubclassListLoadingSelector,
  subclassListSelector,
  isCurrencyListLoadingSelector,
  currencyListSelector,
  isIndustryFocusListLoadingSelector,
  industryFocusListSelector,
  isJurisdicationListLoadingSelector,
  jurisdicationListSelector,
  isRightToApprovedFundExtensionListLoadingSelector,
  rightToApprovedFundExtensionListSelector,
  isThresholdListLoadingSelector,
  thresholdListListSelector,
  isEntityTypeListLoadingSelector,
  entityTypeListSelector,
  isExpectedSizeListLoadingSelector,
  expectedSizeListSelector
} from '../../reducers/db/decisions';
import { uniqBy, filter } from 'lodash';
import { Card } from '../../components/Card/Card';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { Grid, Row, Col } from 'react-bootstrap';
import notify from 'devextreme/ui/notify';
import Accordion from 'devextreme-react/accordion';
import './style.css';

const ReconOptions = [
  {
    label: 'Yes',
    value: 'Yes'
  },
  {
    label: 'No',
    value: 'No'
  },
  {
    label: 'N/A',
    value: 'N/A'
  }
];

const StatusOptions = [
  {
    ID: 'Agreed ,Market',
    Name: 'Agreed ,Market'
  },
  {
    ID: 'Rejected',
    Name: 'Rejected'
  },
  {
    ID: 'N/A',
    Name: 'N/A'
  }
];

class Dashboard extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      sectionId: '',
      multiple: true,
      collapsible: true,
      animationDuration: 300
    };

    this.accordianRef = React.createRef();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.collapseAll = this.collapseAll.bind(this);
    this.expandAll = this.expandAll.bind(this);
  }

  componentDidMount() {
    this.setPageSources();
  }

  componentDidUpdate(prevProps) {
    const { sectionList, selectedSectionId } = this.props;
    const dealId = localStorage.getItem('dealId');
    if (this.props.sectionList !== prevProps.sectionList) {
      //Called for dashboard default path
      if (sectionList[0].length > 0) {
        window.localStorage.setItem('section', sectionList[0][0].entityName);
      }
      if (sectionList[0].length > 0 && dealId.length > 0) {
        this.props.getChecklistItemsList({
          dealId: dealId,
          sectionId: sectionList[0][0].id
        });
        this.setState({ sectionId: sectionList[0][0].id });
      }
    }
    if (this.props.selectedSectionId !== prevProps.selectedSectionId) {
      //Called for Switching of dashboardIds
      this.props.getChecklistItemsList({
        dealId: dealId,
        sectionId: selectedSectionId
      });
      this.setState({ sectionId: selectedSectionId });
    }
  }
  setPageSources() {
    this.props.getSections();
    this.props.getExpectedSizeList({
      inputSource: 'Expected Size'
    });
    this.props.getSubclassList({
      inputSource: 'Fund Subclass'
    });
    this.props.getCurrencyList({
      inputSource: 'Currency List'
    });
    this.props.getIndustryFocusList({
      inputSource: 'Industry Focus'
    });
    this.props.getJurisdicationList({
      inputSource: 'Jurisdictions'
    });
    this.props.getRightToApprovedFundExtensionList({
      inputSource: 'Right to Approve Fund Extensions'
    });
    this.props.getThresholdList({
      inputSource: 'Thresholds'
    });
    this.props.getEntityTypeList({
      inputSource: 'Type of Entity'
    });
  }

  handleSubmit = event => {
    event.preventDefault();
    const checklistItems = filter(
      this.props.allChecklistItems.sectionChecklistItemsForDeal,
      setting => setting.id
    );

    checklistItems.length > 0 &&
      checklistItems.map(prop => {
        prop.input = event.target[prop.sectionId + 'Input' + prop.id].value;
        prop.reference =
          event.target[prop.sectionId + 'Reference' + prop.id].value;
        prop.notes = event.target[prop.sectionId + 'Notes' + prop.id].value;
        prop.reconToMarketTerm =
          event.target[prop.sectionId + 'ReconToMarketTerm' + prop.id].value;
        prop.usMarketASPInitialPosition =
          event.target[
            prop.sectionId + 'USMarketASPInitialPosition' + prop.id
          ].value;
        prop.initialReview =
          event.target[prop.sectionId + 'InitialReview' + prop.id].value;
        prop.state = event.target[prop.sectionId + 'State' + prop.id].value;
        prop.output = event.target[prop.sectionId + 'Output' + prop.id].value;
        prop.sectionId = event.target[prop.sectionId + prop.id].value;
        return prop;
      });

    this.props.saveChecklistItems({
      RequestType: 'SaveCheckListItems',
      ChecklistItems: checklistItems
    });
    const type = 'success';
    const text = 'Checklist saved!';

    notify(text, type, 300);
  };

  handleChange = name => event => {
    this.setState({ [name]: event.value });
  };

  handleViewNegotiation = prop => {
    this.props.openModal({
      name: 'view-negotiation',
      data: {
        questionId: prop.id,
        questionName: prop.entityName
      },
      display: {
        opacity: 0.2,
        height: 360,
        width: 560
      }
    });
  };

  handleCreateNegotiation = prop => {
    this.props.openModal({
      name: 'create-negotiation',
      data: {
        questionId: prop.id,
        questionName: prop.entityName
      },
      display: {
        opacity: 0.2,
        height: 360,
        width: 560
      }
    });
  };

  expandAll = () => {
    const itemCount = this.accordianRef.current.props.dataSource.length;
    for (let i = 0; i <= itemCount - 1; i++) {
      this.accordianRef.current.instance.expandItem(i);
    }
  };

  collapseAll = () => {
    const itemCount = this.accordianRef.current.props.dataSource.length;
    for (let i = 0; i <= itemCount - 1; i++) {
      this.accordianRef.current.instance.collapseItem(i);
    }
  };

  CustomTitle(data) {
    return <h1>{data}</h1>;
  }

  CustomItemRender = checklistItems => data => {
    const expectedSizeOptions =
      this.props.expectedSizeList.expectedSizeList || [];
    const subclassListOptions = this.props.subclassList.subclassList || [];
    const currencyListOptions = this.props.currencyList.currencyList || [];
    const industryFocusListOptions =
      this.props.industryFocusList.industryFocusList || [];
    const jurisdicationListOptions =
      this.props.jurisdicationList.jurisdicationList || [];
    const rightToApprovedFundExtensionListOptions =
      this.props.rightToApprovedFundExtensionList
        .rightToApprovedFundExtensionList || [];
    const thresholdListOptions = this.props.thresholdList.thresholdList || [];
    const entityTypeListOptions =
      this.props.entityTypeList.entityTypeList || [];
    return (
      <div>
        {checklistItems.length > 0 &&
          filter(checklistItems, x => x.question === data).map(
            (prop, index) => {
              return (
                <div key={index} className="margintop-10px">
                  <Row className="content-font">
                    <Col md={2}>
                      {prop.entityName}

                      <br />
                      <div className="margintop-5px">
                        <i
                          title="Add Negotiation History"
                          className="decisions-button fas fa-notes-medical fas-negotiation-size"
                          onClick={() =>
                            this.handleCreateNegotiation(prop)
                          }></i>
                        <i
                          title="View Negotiation History"
                          className="decisions-button fas fa-handshake fas-negotiation-size margin-left20px"
                          onClick={() => this.handleViewNegotiation(prop)}></i>
                      </div>
                    </Col>
                    <Col md={2}>
                      <input
                        type="hidden"
                        name={prop.sectionId + prop.id}
                        value={prop.sectionId}
                      />
                      {prop.inputType === 'Textbox' && (
                        <TextArea
                          height={60}
                          className="name-field Width100pct"
                          id={prop.sectionId + 'Input' + prop.id}
                          name={prop.sectionId + 'Input' + prop.id}
                          value={
                            this.state[prop.sectionId + 'Input' + prop.id] ===
                            undefined
                              ? prop.input
                              : this.state[prop.sectionId + 'Input' + prop.id]
                          }
                          onValueChanged={this.handleChange(
                            prop.sectionId + 'Input' + prop.id
                          )}
                        />
                      )}
                      {prop.inputType === 'Datepicker' && (
                        <DateBox
                          id={prop.sectionId + 'Input' + prop.id}
                          name={prop.sectionId + 'Input' + prop.id}
                          value={
                            this.state[prop.sectionId + 'Input' + prop.id] ===
                            undefined
                              ? prop.input
                              : this.state[prop.sectionId + 'Input' + prop.id]
                          }
                          onValueChanged={this.handleChange(
                            prop.sectionId + 'Input' + prop.id
                          )}
                        />
                      )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Expected Size' && (
                          <SelectBox
                            items={expectedSizeOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Currency List' && (
                          <SelectBox
                            items={currencyListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Fund Subclass' && (
                          <SelectBox
                            items={subclassListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Industry Focus' && (
                          <SelectBox
                            items={industryFocusListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Thresholds' && (
                          <SelectBox
                            items={thresholdListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}

                      {prop.inputType === 'Combobox' &&
                        prop.inputSource ===
                          'Right to Approve Fund Extensions' && (
                          <SelectBox
                            items={rightToApprovedFundExtensionListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Jurisdictions' && (
                          <SelectBox
                            items={jurisdicationListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                      {prop.inputType === 'Combobox' &&
                        prop.inputSource === 'Entity Types' && (
                          <SelectBox
                            items={entityTypeListOptions}
                            id={prop.sectionId + 'Input' + prop.id}
                            name={prop.sectionId + 'Input' + prop.id}
                            value={
                              this.state[prop.sectionId + 'Input' + prop.id] ===
                              undefined
                                ? prop.input
                                : this.state[prop.sectionId + 'Input' + prop.id]
                            }
                            onValueChanged={this.handleChange(
                              prop.sectionId + 'Input' + prop.id
                            )}
                          />
                        )}
                    </Col>
                    <Col md={2}>
                      <TextBox
                        id={prop.sectionId + 'Reference' + prop.id}
                        name={prop.sectionId + 'Reference' + prop.id}
                        value={
                          this.state[prop.sectionId + 'Reference' + prop.id] ===
                          undefined
                            ? prop.reference
                            : this.state[prop.sectionId + 'Reference' + prop.id]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'Reference' + prop.id
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <TextArea
                        height={60}
                        id={prop.sectionId + 'Notes' + prop.id}
                        name={prop.sectionId + 'Notes' + prop.id}
                        value={
                          this.state[prop.sectionId + 'Notes' + prop.id] ===
                          undefined
                            ? prop.notes
                            : this.state[prop.sectionId + 'Notes' + prop.id]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'Notes' + prop.id
                        )}
                      />
                    </Col>
                    <Col md={1}>
                      <SelectBox
                        dataSource={ReconOptions}
                        displayExpr="label"
                        valueExpr="value"
                        id={prop.sectionId + 'ReconToMarketTerm' + prop.id}
                        name={prop.sectionId + 'ReconToMarketTerm' + prop.id}
                        value={
                          this.state[
                            prop.sectionId + 'ReconToMarketTerm' + prop.id
                          ] === undefined
                            ? prop.reconToMarketTerm
                            : this.state[
                                prop.sectionId + 'ReconToMarketTerm' + prop.id
                              ]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'ReconToMarketTerm' + prop.id
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <TextArea
                        height={60}
                        className="name-field Width100pct"
                        id={
                          prop.sectionId +
                          'USMarketASPInitialPosition' +
                          prop.id
                        }
                        name={
                          prop.sectionId +
                          'USMarketASPInitialPosition' +
                          prop.id
                        }
                        value={
                          this.state[
                            prop.sectionId +
                              'USMarketASPInitialPosition' +
                              prop.id
                          ] === undefined
                            ? prop.USMarketASPInitialPosition
                            : this.state[
                                prop.sectionId +
                                  'USMarketASPInitialPosition' +
                                  prop.id
                              ]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId +
                            'USMarketASPInitialPosition' +
                            prop.id
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <TextArea
                        height={60}
                        className="name-field Width100pct"
                        id={prop.sectionId + 'InitialReview' + prop.id}
                        name={prop.sectionId + 'InitialReview' + prop.id}
                        value={
                          this.state[
                            prop.sectionId + 'InitialReview' + prop.id
                          ] === undefined
                            ? prop.initialReview
                            : this.state[
                                prop.sectionId + 'InitialReview' + prop.id
                              ]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'InitialReview' + prop.id
                        )}
                      />
                    </Col>

                    <Col md={1}>
                      <SelectBox
                        dataSource={StatusOptions}
                        displayExpr="Name"
                        valueExpr="ID"
                        id={prop.sectionId + 'State' + prop.id}
                        name={prop.sectionId + 'State' + prop.id}
                        value={
                          this.state[prop.sectionId + 'State' + prop.id] ===
                          undefined
                            ? prop.state
                            : this.state[prop.sectionId + 'State' + prop.id]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'State' + prop.id
                        )}
                      />
                    </Col>
                    <Col md={2}>
                      <TextArea
                        height={60}
                        className="name-field"
                        id={prop.sectionId + 'Output' + prop.id}
                        name={prop.sectionId + 'Output' + prop.id}
                        value={
                          this.state[prop.sectionId + 'Output' + prop.id] ===
                          undefined
                            ? prop.output
                            : this.state[prop.sectionId + 'Output' + prop.id]
                        }
                        onValueChanged={this.handleChange(
                          prop.sectionId + 'Output' + prop.id
                        )}
                      />
                    </Col>
                  </Row>
                </div>
              );
            }
          )}
      </div>
    );
  };

  render() {
    const { multiple, collapsible, animationDuration } = this.state;
    const checklistItems = filter(
      this.props.allChecklistItems.sectionChecklistItemsForDeal,
      setting => setting.id
    );
    const questions = uniqBy(checklistItems, 'question').map(x => x.question);

    return (
      <div className="dashboard questions" onClick={this.handleCancel}>
        <div className="dashboard-empty-message">
          <Grid fluid>
            <Row>
              <Col md={12}>
                <Card
                  ctTableFullWidth
                  content={
                    <React.Fragment>
                      <div className="content">
                        <div className="daterange-filters-title"></div>
                        <form onSubmit={this.handleSubmit}>
                          <div className="daterange-filters-footer">
                            <i
                              class="fas fa-plus-square floatLeft cusorHand margintop20px"
                              title="Expand All"
                              onClick={this.expandAll}></i>
                            <i
                              class="fas fa-minus-square marginleft20px floatLeft cusorHand margintop20px"
                              title="Collapse All"
                              onClick={this.collapseAll}></i>

                            <FormButton
                              primary
                              type="submit"
                              label="Save"
                              className="MarginRight300"
                            />
                            <br />
                            <br />
                          </div>

                          <Row className="header-font headerRow">
                            <Col className="headermd1">Checklist Name</Col>
                            <Col className="headermd2">Inputs</Col>
                            <Col className="headermd3">Reference</Col>
                            <Col className="headermd4">Notes</Col>
                            <Col className="headermd5">
                              Recon to Market Term
                            </Col>
                            <Col className="headermd6">
                              US Market/ASP Initial Position
                            </Col>
                            <Col className="headermd7">
                              ASP Counsel Inital Recommendation
                            </Col>
                            <Col className="headermd8">Status</Col>
                            <Col className="headermd9">Output</Col>
                          </Row>
                          <div id="accordion">
                            <Accordion
                              dataSource={questions}
                              ref={this.accordianRef}
                              collapsible={collapsible}
                              multiple={multiple}
                              animationDuration={animationDuration}
                              itemTitleRender={this.CustomTitle}
                              itemRender={this.CustomItemRender(checklistItems)}
                            />
                          </div>
                          <div className="daterange-filters-footer ">
                            <FormButton
                              primary
                              type="submit"
                              label="Save"
                              className="MarginRight300"
                            />
                          </div>
                        </form>
                      </div>
                    </React.Fragment>
                  }
                />
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    allChecklistItemsForDealLoading: isSectionChecklistItemsForDealLoadingSelector(
      state,
      props
    ),
    allChecklistItems: sectionChecklistItemsForDealListSelector(state, props),

    sectionListLoading: isSectionsLoadingSelector(state, props),
    sectionList: sectionListSelector(state, props),

    selectedSectionId: props.match.params.sectionId,

    subclassListLoading: isSubclassListLoadingSelector(state, props),
    subclassList: subclassListSelector(state, props),

    currencyListLoading: isIndustryFocusListLoadingSelector(state, props),
    currencyList: currencyListSelector(state, props),

    industryFocusListLoading: isCurrencyListLoadingSelector(state, props),
    industryFocusList: industryFocusListSelector(state, props),

    jurisdicationListLoading: isJurisdicationListLoadingSelector(state, props),
    jurisdicationList: jurisdicationListSelector(state, props),

    rightToApprovedFundExtensionListLoading: isRightToApprovedFundExtensionListLoadingSelector(
      state,
      props
    ),
    rightToApprovedFundExtensionList: rightToApprovedFundExtensionListSelector(
      state,
      props
    ),

    thresholdListListLoading: isThresholdListLoadingSelector(state, props),
    thresholdList: thresholdListListSelector(state, props),

    expectedSizeListLoading: isExpectedSizeListLoadingSelector(state, props),
    expectedSizeList: expectedSizeListSelector(state, props),

    entityTypeListLoading: isEntityTypeListLoadingSelector(state, props),
    entityTypeList: entityTypeListSelector(state, props)
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      openModal: modalRoutines.openModal,
      closeModal: modalRoutines.closeModal,
      getChecklistItemsList: decisionsActions.getSectionChecklistItemsForDeal,
      saveChecklistItems: decisionsActions.saveChecklistItems,
      getSections: decisionsActions.getSections,

      getSubclassList: decisionsActions.getSubclassList,
      getCurrencyList: decisionsActions.getCurrencyList,
      getIndustryFocusList: decisionsActions.getIndustryFocusList,
      getJurisdicationList: decisionsActions.getJurisdicationList,
      getExpectedSizeList: decisionsActions.getExpectedSizeList,
      getRightToApprovedFundExtensionList:
        decisionsActions.getRightToApprovedFundExtensionList,
      getThresholdList: decisionsActions.getThresholdList,
      getEntityTypeList: decisionsActions.getEntityTypeList
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'Dashboard'
  })(Dashboard)
);
